import apiClient from './client'
import type { RemedyRule } from '../types'

export const ruleApi = {
  getList: async (
    skip = 0,
    limit = 100,
    enabled_only = false
  ): Promise<RemedyRule[]> => {
    return apiClient.get('/rules', { params: { skip, limit, enabled_only } })
  },

  create: async (data: any): Promise<RemedyRule> => {
    return apiClient.post('/rules', data)
  },

  getById: async (id: number): Promise<RemedyRule> => {
    return apiClient.get(`/rules/${id}`)
  },

  update: async (id: number, data: any): Promise<RemedyRule> => {
    return apiClient.put(`/rules/${id}`, data)
  },

  toggle: async (id: number): Promise<RemedyRule> => {
    return apiClient.post(`/rules/${id}/toggle`)
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/rules/${id}`)
  },
}

export default ruleApi
